<template>
    <div class="data_chartmain">
      <div class="datarbox">
        所属大棚
        <el-select
          v-model="greenhouseId"
          placeholder="选择大棚"
          @change="handleGreenhouseChange"
          style="width: 200px"
        >
          <el-option
            v-for="item in greenhouseOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
  
        业务场景
        <el-select v-model="sbtypeed" placeholder="请选择" @change="sbtypeclick">
          <el-option label="全部场景" key="全部场景" value="全部场景"></el-option>
          <el-option
            :label="item"
            v-for="item in sbtypelist"
            :key="item"
            :value="item"
          ></el-option>
        </el-select>
  
        <!-- 数据类型 <el-select v-model="datetype" placeholder="请选择" @change="datetimechange">
                  <el-option label="实时数据" value="1"></el-option>
                  <el-option label="近24小时" value="2"></el-option>
                  <el-option label="最近一周" value="3"></el-option>
                  <el-option label="最近一月" value="4"></el-option>
              </el-select> -->
        <el-radio-group v-model="datetype" @change="datetimechange" size="medium">
          <!-- <el-radio-button label="1">实时数据</el-radio-button> -->
          <el-radio-button label="2">近24小时</el-radio-button>
          <el-radio-button label="3">最近一周</el-radio-button>
          <el-radio-button label="4">最近一月</el-radio-button>
        </el-radio-group>
        <el-date-picker
          v-if="datetype == 3 || datetype == 4"
          v-model="times"
          type="daterange"
          style="width: 400px"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @change="timechange"
        ></el-date-picker>
        <el-date-picker
          v-else
          v-model="times"
          style="width: 400px"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd HH:mm:ss"
          @change="timechange"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
  
        <el-button type="primary" @click="getcheckeddata">查询</el-button>
      </div>
      <div class="datachartbox">
        <el-table
          :data="tabledata"
          style="margin: 20px 10px; width: calc(100% - 20px)"
          height="66vh"
        >
          <el-table-column
            type="index"
            width="70"
            label="序号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="type"
            label="业务场景"
            align="center"
            width="100"
          ></el-table-column>
          <el-table-column prop="content" label="AI推送详情" align="left">
            <template slot-scope="scope">
              <p>{{ scope.row.createTime }}</p>
              {{ scope.row.content }}
            </template>
          </el-table-column>
          <el-table-column
            prop="executionStatus"
            label="执行状态"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.executionStatus === 100"
                class="action-buttons"
              >
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleExecute(scope.row)"
                  >执行</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  @click="handleIgnore(scope.row)"
                  >忽略</el-button
                >
              </div>
              <div v-else class="statusbtn btn0">
                {{ setExecutionStatus(scope.row.executionStatus) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="设备状态"
            align="center"
            width="180"
          >
            <template slot-scope="scope">
              <div class="statusbtn btn0">{{ scope.row.status || "-" }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="time"
            label="运行时间(秒)"
            align="center"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="statusTime"
            label="状态变更时间"
            align="center"
            width="220"
          ></el-table-column>
        </el-table>
        <el-pagination
          :page-size="20"
          background
          @current-change="pagechange"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </template>
  
  <script>
  import router from "../router";
  import axios from "axios";
  import * as echarts from "echarts";
  import {
    getFormatDateAdd,
    getSmpFormatDate,
    getFormatDateHourAdd,
  } from "../utils/timeformat";
  import { getcjlist, getallsblist, getwarlist, aiTaskControl } from "@/api/bot";
  import { baseUrl } from "@/axios/baseUrl";
  //
  export default {
    name: "index",
    components: {},
    props: {
      sbname: { type: String },
    },
    data(props) {
      return {
        menu: 0,
        // 大棚相关
        greenhouseOptions: [],
        greenhouseId: "",
        sbtypelist: [],
        ssbtypelist: [],
        propsbname: props.sbname,
        page: 1,
        tabledata: [],
        sbtypeed: "全部场景",
        ssbtypeed: "",
        datetype: "2",
        times: [
          getFormatDateHourAdd(getSmpFormatDate(), -12),
          getSmpFormatDate(),
        ],
        valuekeylist: {
          大气环境监测传感器: [
            {
              name: "温度",
              value: "temp",
              unit: "℃",
            },
            {
              name: "湿度",
              value: "humi",
              unit: "%",
            },
            {
              name: "二氧化碳",
              value: "co2",
              unit: "ppm",
            },
            {
              name: "光照",
              value: "light",
              unit: "Lux",
            },
          ],
          土壤氮磷钾传感器: [
            {
              name: "含氮量",
              value: "nitrogen",
              unit: "mg/kg",
            },
            {
              name: "含磷量",
              value: "phosphorus",
              unit: "mg/kg",
            },
            {
              name: "含钾量",
              value: "potassium",
              unit: "mg/kg",
            },
          ],
          土壤温湿度EC传感器: [
            {
              name: "含水率",
              value: "water",
              unit: "%RH",
            },
            {
              name: "温度",
              value: "temp",
              unit: "℃",
            },
            {
              name: "电导率",
              value: "conductivity",
              unit: "us/cm",
            },
          ],
          土壤PH传感器: [
            {
              name: "PH值",
              value: "ph",
              unit: "",
            },
          ],
          棚外气象站: [
            {
              name: "风力",
              value: "windRank",
              unit: "级",
            },
            {
              name: "风速",
              value: "windSpeed",
              unit: "m/s",
            },
            {
              name: "风向",
              value: "windDirection",
              unit: "",
            },
            {
              name: "温度",
              value: "temp",
              unit: "℃",
            },
            {
              name: "湿度",
              value: "humi",
              unit: "%",
            },
            {
              name: "光照",
              value: "light",
              unit: "",
            },
            {
              name: "大气压",
              value: "pressure",
              unit: "kPa",
            },
            {
              name: "累计雨量",
              value: "rainfall",
              unit: "mm",
            },
            {
              name: "瞬时雨量",
              value: "instantRainfall",
              unit: "mm",
            },
            {
              name: "当前雨量",
              value: "currentRainfall",
              unit: "mm",
            },
            {
              name: "日雨量",
              value: "yesterdayRainfall",
              unit: "mm",
            },
          ],
        },
        total: 0,
      };
    },
    computed: {},
    mounted() {
      console.log("传进来的", this.propsbname);
      this.fetchGreenhouseOptions();
    },
    methods: {
      setExecutionStatus(executionStatus) {
        switch (executionStatus) {
          case 100:
            return "待执行";
          case 200:
            return "执行中";
          case 300:
            return "已执行";
          case 400:
            return "已忽略";
        }
        return "-";
      },
      timechange(times) {
        console.log(times);
        if (
          new Date(times[1]).getTime() - new Date(times[0]).getTime() >
          2592000000
        ) {
          // 30天的毫秒数
          this.$message.error("最多选择30天");
          this.times = [];
        }
      },
      pagechange(e) {
        this.page = e;
        console.log(this.page, e);
        setTimeout(() => {
          this.getcheckeddata();
        }, 100);
      },
      getcheckeddata() {
        let params = `end=${this.times[1]}&page=${this.page}&size=20&start=${
          this.times[0]
        }&type=${this.sbtypeed == "全部场景" ? "" : this.sbtypeed}`;
        if (this.greenhouseId) {
          params += `&greenhouseId=${this.greenhouseId}`;
        }
        getwarlist(params).then((res) => {
          console.log("历史数据", res.data);
          this.tabledata = res.data.records;
          this.total = parseInt(res.data.totalRow);
        });
      },
      // 获取大棚下拉选项
      async fetchGreenhouseOptions() {
        const formData = new FormData();
        formData.append("enableStatus", 1);
        try {
          const greenhouseRes = await axios.post(
            baseUrl + "/api/basic/greenhouse/selection",
            formData
          );
          this.greenhouseOptions = (greenhouseRes.data || []).map((item) => ({
            label: item.serialNumber,
            value: item.id,
          }));
          // 默认选中第一个大棚
          if (this.greenhouseOptions.length) {
            this.greenhouseId = this.greenhouseOptions[0].value;
            this.handleGreenhouseChange();
          } else {
            // 如果没有大棚，直接获取业务场景列表
            this.getsbtypelist();
          }
        } catch (error) {
          console.error("获取大棚列表失败:", error);
          // 即使失败也继续获取业务场景列表
          this.getsbtypelist();
        }
      },
      // 大棚变化处理
      handleGreenhouseChange() {
        // 重置分页
        this.page = 1;
        // 重新获取业务场景列表和数据
        this.getsbtypelist();
      },
      getsbtypelist() {
        getcjlist().then((res) => {
          console.log("res.data333333333", res.data, this.propsbname);
          this.sbtypelist = res.data;
          setTimeout(() => {
            this.getcheckeddata();
          }, 200);
        });
      },
      sbtypeclick() {},
      // 执行任务
      handleExecute(row) {
        this.$confirm("确定要执行该任务吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          aiTaskControl(`id=${row.id}&control=1`)
            .then((res) => {
              this.$message.success("任务执行成功");
              this.getcheckeddata(); // 刷新数据
            })
            .catch((err) => {
              this.$message.error("任务执行失败");
              console.error(err);
            });
        });
      },
      // 忽略任务 
      handleIgnore(row) {
        this.$confirm("确定要忽略该任务吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          aiTaskControl(`id=${row.id}&control=0`)
            .then((res) => {
              this.$message.success("任务已忽略");
              this.getcheckeddata(); // 刷新数据
            })
            .catch((err) => {
              this.$message.error("忽略任务失败");
              console.error(err);
            });
        });
      },
      datetimechange() {
        let time = [];
        switch (this.datetype) {
          case "1":
            time = [
              getFormatDateHourAdd(getSmpFormatDate(), -12),
              getSmpFormatDate(),
            ];
            break;
          case "2":
            time = [
              getFormatDateHourAdd(getSmpFormatDate(), -24),
              getSmpFormatDate(),
            ];
            break;
          case "3":
            time = [
              getFormatDateAdd(getSmpFormatDate(), -7).substr(0, 10),
              getSmpFormatDate().substr(0, 10),
            ];
            break;
          case "4":
            time = [
              getFormatDateAdd(getSmpFormatDate(), -30).substr(0, 10),
              getSmpFormatDate().substr(0, 10),
            ];
            break;
          default:
            break;
        }
        this.times = time;
      },
    },
  };
  </script>
  
  <style scoped lang="less">
  @font-face {
    font-family: "title";
    src: url("../assets/font/title.ttf");
  }
  
  .data_chartmain {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #030a2e;
  
    .datamenubox {
      margin: 10px;
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 10px;
  
      .datamenuitem {
        padding: 10px 20px;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        background-color: #203663;
      }
  
      .died {
        background-color: #0691ed;
      }
    }
  
    .datarbox {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #ffffff;
      padding-top: 5px;
    }
  
    .datachartbox {
      .statusbtn {
        padding: 4px 8px;
        background-color: #f92c1510;
        color: #f92c15;
        border-radius: 4px;
      }
  
      .btn0 {
        background-color: #2680dd69;
        color: #2680dd;
      }
  
      .action-buttons {
        display: flex;
        gap: 8px;
        justify-content: center;
      }
    }
  }
  
  /deep/ .el-input__inner {
    color: #fff;
  }
  
  /deep/ .el-radio-button__inner,
  /deep/ .el-checkbox-button__inner {
    color: #e7f0ff;
    background: transparent;
    border: 1px solid #2680dd;
  }
  
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background: #2680dd;
    border: 1px solid #2680dd;
  }
  
  /deep/ .el-input__inner,
  /deep/ .el-range-input {
    background-color: transparent;
  }
  
  /deep/ .el-checkbox-button:first-child .el-checkbox-button__inner,
  /deep/ .el-radio-button:first-child .el-radio-button__inner {
    border-left: 1px solid #2680dd;
  }
  
  /deep/ .el-input__inner {
    border: 1px solid #2680dd;
    margin: 0 10px;
  }
  
  /deep/ .el-date-editor .el-range-separator {
    color: #fff;
  }
  
  /deep/ .el-date-editor .el-range-input {
    color: #fff;
  }
  
  /deep/ .el-select {
    margin-right: 30px;
  }
  
  /deep/ .el-table,
  /deep/ .el-table th.el-table__cell,
  /deep/ .el-table tr,
  /deep/ .el-table .el-table__cell.is-center,
  /deep/ .el-table td.el-table__cell {
    background-color: transparent;
    border: 1px solid #007cff50;
    color: #fff;
    font-size: 18px;
  }
  
  /deep/ .el-table::before {
    background-color: transparent;
  }
  
  /deep/ .el-pagination {
    text-align: center;
  }
  
  /deep/ .el-table .el-table__body tr:hover > td {
    background-color: inherit !important;
  }
  </style>
  
